const elemChildLinks = document.querySelectorAll('.wt-AirlinePriceChart');
window.fireOnVisible(elemChildLinks, async (articleInfo) => {
    await import('./assets/css/airlinepricechart.scss');
});
